import {
  CategoryType,
  Color,
  GeneralCategory,
  GetProdutcsResult,
  Product,
  Size,
  Sort,
} from "../../domain";
import {
  Endpoints,
  RemoteDataSource,
  ProductsRemoteDataSourceError,
} from "../core";

export class ProductsRemoteDataSource extends RemoteDataSource {
  public async getProductInfo(id: string): Promise<Product> {
    try {
      const res = await this.get(Endpoints.productInfo, { id });
      return new Product().deserialize(res.data);
    } catch (error) {
      if (!error.response) throw ProductsRemoteDataSourceError.networkError();
      if (error.response.status === 404)
        throw ProductsRemoteDataSourceError.productNotFoundError();
      throw ProductsRemoteDataSourceError.serverError();
    }
  }

  public async getCategories(): Promise<GeneralCategory[]> {
    try {
      const res = await this.get(Endpoints.generalCategoriesList);
      return res.data.map((json: any) =>
        new GeneralCategory().deserialize(json)
      );
    } catch (error) {
      if (!error.response) throw ProductsRemoteDataSourceError.networkError();
      throw ProductsRemoteDataSourceError.serverError();
    }
  }

  public async getColors(): Promise<Color[]> {
    try {
      const res = await this.get(Endpoints.color);
      return res.data.map((json: any) => new Color().deserialize(json));
    } catch (error) {
      if (!error.response) throw ProductsRemoteDataSourceError.networkError();
      throw ProductsRemoteDataSourceError.serverError();
    }
  }

  public async getSizes(): Promise<Size[]> {
    try {
      const res = await this.get(Endpoints.sizesList);
      return res.data.map((json: any) => new Size().deserialize(json));
    } catch (error) {
      if (!error.response) throw ProductsRemoteDataSourceError.networkError();
      throw ProductsRemoteDataSourceError.serverError();
    }
  }

  public async getProducts(
    categoryId: string,
    categoryType: CategoryType,
    page: number,
    sizes: Size[],
    colors: Color[],
    sort: Sort
  ): Promise<GetProdutcsResult> {
    try {
      let url = Endpoints.categoryProducts;
      if (categoryType === "generalCategory")
        url = Endpoints.generalCategoryProducts;
      else if (categoryType === "subCategory")
        url = Endpoints.subCategoryProducts;
      const res = await this.get(url, {
        page,
        id: categoryId,
        size:
          sizes.length === 0
            ? ""
            : JSON.stringify(sizes.map((size) => size.size)),
        color:
          colors.length === 0
            ? ""
            : JSON.stringify(colors.map((color) => color.id)),
        sort,
      });
      return {
        products: res.data.products.map((json: any) =>
          new Product().deserialize(json)
        ),
        productsCount: res.data.count,
        pageSize: res.data.page_size,
      };
    } catch (error) {
      if (!error.response) throw ProductsRemoteDataSourceError.networkError();
      if (error.response.status === 404)
        throw ProductsRemoteDataSourceError.categoryNotFoundError();
      throw ProductsRemoteDataSourceError.serverError();
    }
  }

  public async getCartProducts(ids: string[]): Promise<Product[]> {
    try {
      const res = await this.get(Endpoints.cartProducts, {
        ids: JSON.stringify(ids),
      });
      return res.data.map((json: any) => new Product().deserialize(json));
    } catch (error) {
      if (!error.response) throw ProductsRemoteDataSourceError.networkError();
      throw ProductsRemoteDataSourceError.serverError();
    }
  }
}
